import { render, staticRenderFns } from "./Memorias.vue?vue&type=template&id=90fcb4e4&scoped=true&"
import script from "./Memorias.vue?vue&type=script&lang=js&"
export * from "./Memorias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fcb4e4",
  null
  
)

export default component.exports